<template>
  <bean-dialog-form
    :columns="columns"
    v-model="form"
    v-bind="$attrs"
  >
    <el-button type="primary">拒绝</el-button>
  </bean-dialog-form>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { formColumnsExtend } from '@/admin_grapes/users.js';
import _ from 'lodash';

@Component
export default class RejectFormDialog extends Vue {
  @Prop({ type: Object }) data;
  @Prop({ type: Array }) rejectReasons;

  form = {};

  get columns() {
    return formColumnsExtend([
      {
        key: 'reject_reason',
        renderCell: {
          required: true
        }
      },
      {
        prop: 'reject_reasons',
        label: '常用拒绝原因',
        renderCell: () => {
          return (
            <div>
              {
                _.map(this.rejectReasons, (object) => {
                  return (<el-tag type="info" style="margin-right: 10px; cursor: pointer;" onClick={() => this.handleApplyRejectReason(object.reason)}>{object.reason}</el-tag>)
                })
              }
            </div>
          );
        }
      }
    ].filter(Boolean), { data: this.data, type: 'edit' });
  }

  handleApplyRejectReason(reason) {
    this.form = {
      ...this.form,
      reject_reason: reason
    }
  }

}
</script>

<style lang="scss" scoped>


</style>
